import { isNil } from 'lodash';

import { EventData } from '@pwp-common';

import { DATETIME_LOCAL_CONTROL_STR_FORMAT } from '../../../../../../common/objects/form-helper';
import { defaultEventCreateDialogEditorOutput } from '../default-event-create-dialog-editor-output';
import { EventCreateDialogEditorOutput } from '../event-create-dialog-editor-output';

export const dbToEventCreateDialogEditorOutput = (params: {
  eventData: EventData | undefined | null;
  timezone: string;
}): EventCreateDialogEditorOutput => {
  if (isNil(params.eventData)) {
    return defaultEventCreateDialogEditorOutput;
  }

  const { eventData, timezone } = params;

  return {
    startTime: eventData.getStart().tz(timezone).format(DATETIME_LOCAL_CONTROL_STR_FORMAT),
    endTime: eventData.getEnd().tz(timezone).format(DATETIME_LOCAL_CONTROL_STR_FORMAT),
    isRepeating: false,
    rrule: '',
    repeatEnd: '',
    repeatEndDate: '',
    extendScheduleNumDays: 90,
    assignedUserId: eventData.getAssignedUserId() ?? '',
    assignedBackupUserId: eventData.getAssignedBackupUserId() ?? '',
  };
};
